import styled from 'styled-components';

export const ClueWrapper = styled.div`
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: repeat(5, 1fr);
        grid-column-gap: 0px;
        grid-row-gap: 5px;
    `;